// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { ResourceInfoMessageArgs_abstract } from './../abstract/SagaBase/ResourceInfoMessageArgs_abstract';
export class ResourceInfoMessageArgs extends ResourceInfoMessageArgs_abstract {}
